import script from "./titleMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./titleMsg.vue?vue&type=script&setup=true&lang=js"

import "./titleMsg.vue?vue&type=style&index=0&id=4b1667cc&lang=scss"

const __exports__ = script;

export default __exports__